import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const logged = localStorage.getItem('isLoggedIn') === 'true'

  const [isLoggedIn, setIsLoggedIn] = useState(logged);
  const [partido, setPartido] = useState(null);
  const login = () => {
    setIsLoggedIn(true);
  };

  const logout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('token_1')
    setIsLoggedIn(false);
  };

  useEffect(() => {
    localStorage.setItem('isLoggedIn', isLoggedIn);
  }, [isLoggedIn]);

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout , partido, setPartido}}>
      {children}
    </AuthContext.Provider>
  );
};
